import { Link, useLocation, useParams } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { LayoutDashboard, Settings2, ExternalLink, Building2 } from "lucide-react";
import { useConfig } from "@/context/ConfigContext";
import { useMe } from "@/components/admin/AdminGuard";
import { assetUrl } from "@/lib/api";

const NavLink = ({ to, icon: Icon, label, testid }) => {
  const active = useLocation().pathname === to;
  return (
    <Link to={to} data-testid={testid}
      className={`flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium transition-colors ${active ? "bg-brand text-white" : "text-stone-600 hover:bg-stone-100"}`}>
      <Icon className="w-4 h-4" /> <span className="hidden sm:inline">{label}</span>
    </Link>
  );
};

export default function AdminShell({ children }) {
  const { config, slug } = useConfig();
  const { schoolId } = useParams();
  const me = useMe();
  const base = `/admin/schools/${schoolId}`;
  return (
    <div className="min-h-screen bg-stone-50">
      <header className="sticky top-0 z-30 bg-white/85 backdrop-blur-md border-b">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            {config?.logo_url ? (
              <img src={assetUrl(config.logo_url)} alt="" className="w-9 h-9 rounded-lg object-contain bg-white border" />
            ) : (
              <div className="w-9 h-9 rounded-lg bg-brand text-white flex items-center justify-center font-display font-semibold">
                {config?.institute_name?.[0]}
              </div>
            )}
            <div className="min-w-0">
              <p className="font-display font-semibold leading-tight truncate" data-testid="admin-institute-name">{config?.institute_name}</p>
              <p className="text-xs text-stone-500">{config?.app_name} · School admin</p>
            </div>
          </div>
          <nav className="flex items-center gap-1">
            {me?.role === "super_admin" && <NavLink to="/super" icon={Building2} label="All schools" testid="nav-all-schools" />}
            <NavLink to={base} icon={LayoutDashboard} label="Leads" testid="nav-leads" />
            <NavLink to={`${base}/settings`} icon={Settings2} label="Website" testid="nav-settings" />
            <a href={`/s/${slug}`} target="_blank" rel="noreferrer" className="p-2 rounded-full text-stone-500 hover:bg-stone-100" data-testid="nav-view-site" title="View website">
              <ExternalLink className="w-4 h-4" />
            </a>
            <div className="ml-1" data-testid="admin-user-button"><UserButton /></div>
          </nav>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
